import { queryOptions } from '@tanstack/react-query';
import { getKleosDevice } from '~/services/api/fetchers/kleosDevice.api';
import { KleosQueryKey } from '~/services/queryKeys';

export const myDevicePermissionsQuery = ({
  deviceName,
}: {
  deviceName: string;
}) =>
  queryOptions({
    queryKey: [KleosQueryKey.MY_DEVICE_PERMISSIONS, deviceName],
    queryFn: async () => {
      const device = await getKleosDevice({ deviceName });
      return device.permissions;
    },
  });
